import React from "react";
import contactImage from "../assets/14.jpg";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";

function ContactUs() {
  const emailSubject = "Inquiry";
  const emailBody = "Hello,";

  return (
    <div style={styles.wrapper}>
      <Navbar />

      <div style={styles.heroSection}>
        <div style={styles.overlay}>
          <h2 style={styles.heading}>We'd love to hear from you</h2>
          <p style={styles.subheading}>
            Reach out via WhatsApp, phone, or email — we're just a tap away.
          </p>

          <div style={styles.buttonsContainer}>
            <a
              href="https://wa.me/+254706019613"
              target="_blank"
              rel="noopener noreferrer"
              style={{ ...styles.actionButton, backgroundColor: "#25D366" }}
            >
              📱 WhatsApp Us
            </a>

            <a
              href="tel:+254706019613"
              style={{ ...styles.actionButton, backgroundColor: "#007BFF" }}
            >
              📞 Call Us
            </a>

            {/* Email link styled like the 'Book Now' button */}
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.com&su=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`}
              style={{
                backgroundColor: "#8B4513",
                color: "white",
                padding: "6px 12px",
                fontSize: "0.85rem",
                borderRadius: "5px",
                textDecoration: "none",
                display: "inline-block",
                marginTop: "10px",
                fontWeight: "600",
                textAlign: "center",
                boxSizing: "border-box",
                transition: "transform 0.2s ease",
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              ✉️ Send Us an Email
            </a>
          </div>
        </div>

        <img src={contactImage} alt="Contact Background" style={styles.backgroundImage} />
      </div>

      <Footer />
    </div>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  heroSection: {
    position: "relative",
    flex: 1,
    height: "100vh",
    width: "100%",
    overflow: "hidden",
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    objectFit: "cover",
    zIndex: 0,
  },
  overlay: {
    position: "relative",
    zIndex: 1,
    height: "100%",
    width: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "2rem",
    color: "#fff",
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    marginBottom: "0.5rem",
    textShadow: "0px 0px 10px rgba(0, 0, 0, 0.6)", // For better readability on images
  },
  subheading: {
    fontSize: "1.2rem",
    maxWidth: "600px",
    marginBottom: "2rem",
    textShadow: "0px 0px 8px rgba(0, 0, 0, 0.6)", // For better readability on images
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
    maxWidth: "350px", // Slight max-width for larger screens
  },
  actionButton: {
    padding: "1rem",
    fontSize: "1.1rem",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "8px",
    fontWeight: "600",
    transition: "transform 0.2s ease",
    textAlign: "center",
    boxSizing: "border-box", // To make sure padding is included in button size
  },

  // Responsive Styles
  '@media (max-width: 768px)': {
    heading: {
      fontSize: "2rem",
    },
    subheading: {
      fontSize: "1rem",
    },
    buttonsContainer: {
      maxWidth: "90%", // To give some padding around buttons on smaller screens
    },
    actionButton: {
      fontSize: "1rem",
      padding: "0.8rem",
    },
  },

  '@media (max-width: 480px)': {
    heading: {
      fontSize: "1.7rem", // Smaller heading size on very small screens
    },
    subheading: {
      fontSize: "0.9rem", // Make subheading smaller on small devices
    },
    actionButton: {
      fontSize: "0.9rem", // Smaller buttons on very small screens
      padding: "0.7rem",
    },
  }
};

export default ContactUs;
